import { MembersRegisterPage } from '@/features/members/pages/members-register-page';

const MembersRegisterRoute = () => {
  return <MembersRegisterPage />;
};

export default MembersRegisterRoute;
